import CancelIcon from "@mui/icons-material/Cancel";
import InfoIcon from '@mui/icons-material/Info';
import { Autocomplete, Chip } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import Loading from "components/Loading";
import PhraseLoader from "components/SuperLesson/PhraseLoader";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Tooltip as TooltipLevel, Select as AntSelect } from "antd";
import { debounce, get, map } from "lodash";
import { useCurrentClass } from "store/classes/selectors";
import { handleAddInappropriateAlert } from "store/logs/thunks";
import { handleListStoryAiConfig } from "store/StoryAiCofig/thunks";
import { useCurrentUser, useUserProfileConfig } from "store/users/selectors";
import { checkInappropriateContent } from "utils/methods/word_filter";
import { isErrorContent } from "utils/methods/storyContentValidation";
import sysConf from "config";
import './story.css';
import { useMobileDetect } from 'containers/chat/hooks';
import { moodsOption } from "../../modules/workSheet/helper";

import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Input,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from '@mui/material';
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { getAwsAuthToken } from "utils/lib/authHelper";
import AiUsageModal from "components/Modals/AiInfoModal";
import usePopUpAtOnce from "components/hooks/usePopUpAtOnce";
import { levelsData, ProficiencyTooltipContent } from "./constants";
import { handleLearningModuleCount } from "store/bingo/thunks";
import SentryWrap from 'components/Sentry';



const StyledStoryTextField = muiStyled(TextField)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: '5px 15px',
  borderRadius: '12px',
  maxWidth: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
}));

const StyledSelect = muiStyled(Select)(({ theme }) => ({
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent !important',
  },
}));

const StyledFormControl = muiStyled(FormControl)(({ theme, width = '77%', borderRadius = '30px' }) => ({
  marginLeft: '10px',
  width: width,
  borderRadius: borderRadius,
  '& .MuiSelect-icon': {
    right: '-11px',
    top: 'calc(50% - 15px)',
  },
}));

const StyledAntSelect = styled(AntSelect)`
  width: 100% !important;
  
  .ant-select-selector {
    background-color: #fff !important;
    border: 1px solid #d9d9d9 !important;
    border-radius: 30px !important;
    height: 40px !important;
    padding: 4px 11px !important;
    font-size: 14px !important;
    line-height: 1.5715 !important;
    color: rgba(0, 0, 0, 0.85) !important;
    box-shadow: none !important;
    transition: border-color 0.3s, box-shadow 0.3s !important;
    
    &:hover {
      border-color: #40a9ff !important;
    }
    
    &:focus,
    &.ant-select-focused {
      border-color: #40a9ff !important;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
    }
  }
  
  .ant-select-selection-item {
    line-height: 30px !important;
    color: rgba(0, 0, 0, 0.85) !important;
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  
  .ant-select-selection-placeholder {
    line-height: 30px !important;
    color: rgba(0, 0, 0, 0.6) !important;
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  
  .ant-select-arrow {
    right: 11px !important;
    top: 50% !important;
    // transform: translateY(-50%) !important;
    color: rgba(0, 0, 0, 0.45) !important;
    font-size: 12px !important;
    transition: transform 0.3s !important;
  }
  
  &.ant-select-open .ant-select-arrow {
    transform: translateY(0%) rotate(0deg) !important;
  }
  
  /* Style the dropdown menu to match Material-UI */
  .ant-select-dropdown {
    background-color: #fff !important;
    border-radius: 8px !important;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
    border: 1px solid #d9d9d9 !important;
    padding: 4px 0 !important;
  }
  
  .ant-select-item {
    background-color: #fff !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
    line-height: 1.5715 !important;
    color: rgba(0, 0, 0, 0.85) !important;
    transition: background-color 0.3s !important;
    
    &:hover {
      background-color: #f5f5f5 !important;
    }
    
    &.ant-select-item-option-selected {
      background-color: #e6f7ff !important;
      color: #1890ff !important;
      font-weight: 600 !important;
    }
  }
  
  .ant-select-item-group {
    background-color: #fff !important;
    padding: 8px 12px 4px 12px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.6) !important;
    border-bottom: 1px solid #f0f0f0 !important;
    margin: 0 !important;
  }
  
  /* Remove default Ant Design focus styles */
  &.ant-select-focused .ant-select-selector {
    border-color: #40a9ff !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
  }
`;


const LessonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  margin-top: -20px;
  label {
    width: 190px;
  }
  .MuiFormControl-fullWidth {
    width: 77%;
    margin-left: 10px;
    padding: 0px;
  }
`;

const Label = styled.label`
  color: #fff;
  font-size: 15px;
  font-weight: 400;
`;

const VocContainer = styled.div`  
  display: flex;
  width:100%;
  .MuiAutocomplete-hasClearIcon{
    width:72%;
    margin-left:10px;
  }
  .MuiFormControl-fullWidth{
      border-radius:12px !important;
  }
`;
const MainContainerStory = styled.div`
    display:block !important;
    position:absolute;
    top:-12px;
    left:0px;
`;
const TitleContainer = styled.p`
   text-align:center;
   font-size: 18px;
   font-weight: 600;
   color:white;
`;

const FieldContainer = styled.div`
  label{
    font-size: 15px;
    font-style:normal;
    width:190px;
    display:flex;
    align-items:center;
  }
    .MuiFormControl-fullWidth{
      margin-left:10px;
      width: ${({ width }) => width || '77%'};
      border-radius:${({ borderRadius }) => borderRadius || '30px'};
    }
    .MuiSelect-icon{
      right:-11px;
      top:calc(50% - 15px);
    }
`;
const TwoFiledContainer = styled.div`
    display: flex;
    .MuiFormControl-fullWidth{
      margin-left:10px;
      width: ${({ width }) => width || '77%'};
      border-radius:${({ borderRadius }) => borderRadius || '30px'};
    }
      .PrivateSwitchBase-root-82{
        padding:0px;
      }
`;
const TwoFiledContainerCheck = styled.div`

  label{
    margin-left:6px;
  }
    display: flex;
    gap:10px;
    .MuiFormControl-fullWidth{
      padding: 0px !important;
      margin-left:0px;
      width: ${({ width }) => width || '77%'};
      border-radius:${({ borderRadius }) => borderRadius || '30px'};
    }
      .PrivateSwitchBase-root-82, .PrivateSwitchBase-root-80, .MuiIconButton-root{
        padding:0px !important;
      }
      .MuiTypography-body1{
        text-transform:unset !important;
      }
`;
const CreatedTopicContnt = styled.div`
  margin-top:60px;
`;
const MainContainerSection = styled.div`

`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;


 
 
const UpperMainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction:column;
  height:95%;
  overflow-y:auto;
  overflow-x:hidden;
`;

const CreateFormContainer = styled.div`
  width: ${v => v.isVideoPage ? "100%" : v.loader ? "unset" : v.width + "px"};
  height: ${v => v.isVideoPage ? "100%" :v.loader ? "unset" : v.height + "px"};
  transform:unset !important;
  left:unset !important;
  border-radius:0 !important;
  padding-top:20px;
  padding-bottom:25px;
  top: ${v =>
  v.isVideoPage || v.isBalcon || v.localtionPage
    ? "0px !important"
    : v.isEbook ? "36px !important" : "20px !important"
  };
`;
const languageItems = [
  { value: "spanish", label: "Spanish" },
  { value: "english", label: "English" },
  // { value: "french", label: "French" },
];



const genresSelection = [
  {
    value: "realistic_fiction",
    label:
      "Realistic Fiction – A story that could happen in real life with relatable characters and situations.",
  },
  {
    value: "fantasy",
    label:
      "Fantasy – A story that includes magic, mythical creatures, or supernatural elements.",
  },
  {
    value: "science_fiction",
    label:
      "Science Fiction – A story involving futuristic technology, space exploration, or time travel.",
  },
  {
    value: "mystery",
    label: "Mystery – A story centered around solving a problem.",
  },
  {
    value: "adventure",
    label:
      "Adventure – A story full of action, excitement, and challenges for the main characters.",
  },
  {
    value: "historical_fiction",
    label:
      "Historical Fiction – A story set in a real historical time period with fictional characters or events.",
  },
  {
    value: "comedy",
    label:
      "Comedy – A lighthearted and humorous story designed to entertain and make readers laugh.",
  },
  {
    value: "drama",
    label:
      "Drama – A story focusing on deep emotions, relationships, and personal struggles.",
  },
  {
    value: "fable_folktale",
    label:
      "Fable/Folktale – A short story that teaches a lesson or moral, often with animals or legendary figures.",
  },
  {
    value: "mythology",
    label:
      "Mythology – A story based on traditional myths, gods, and legends from different cultures.",
  },
  {
    value: "narrative",
    label:
      "Narrative – Tells a story with characters, a setting, and a sequence of events.",
  },
  {
    value: "argumentative",
    label:
      "Argumentative – Presents a clear argument and supports it with reasons and evidence.",
  },
  {
    value: "informative",
    label:
      "Informative – Explains or describes a topic to give the reader new information or understanding.",
  },
];



const wordCountData = [
  { value: "100-150", label: "100-150 words" },
  { value: "150-200", label: "150-200 words" },
  { value: "200-250", label: "200-250 words" },
  { value: "250-300", label: "250-300 words" },
  { value: "300-350", label: "300-350 words" },
  { value: "350-400", label: "350-400 words" },
  { value: "400-450", label: "400-450 words" },
  // { value: "450-500", label: "450-500 words" },
  // { value: "500-550", label: "500-550 words" },
  // { value: "550-600", label: "550-600 words" },
];

const gradeLevelData = [
  { value: 3, label: "3rd grade" },
  { value: 4, label: "4th grade" },
  { value: 5, label: "5th grade" },
  { value: 6, label: "6th grade" },
  { value: 7, label: "7th grade" },
  { value: 8, label: "8th grade" },
  { value: 9, label: "9th grade" },
  { value: 10, label: "10th grade" },
  { value: 11, label: "11th grade" },
  { value: 12, label: "12th grade" },
  { value: "college", label: "College level" },
];

const useStyles = () => ({
  menuItemText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '150px',
    display: 'block',
  },
  disabledButton: {
    color: 'white',
    '&.Mui-disabled': {
      color: 'white !important',
    },
  },
  select: {} // Add this if you're using classes.select anywhere
});

const StyledAutocomplete = muiStyled(Autocomplete)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    padding: 0,
    border: 'none',
    '& fieldset': {
      display: 'none',
    },
  },
  '& .MuiInputBase-root::before, & .MuiInputBase-root::after': {
    display: 'none !important',
  },
  '& .MuiAutocomplete-listbox': {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
  },
  '& .MuiAutocomplete-tag': {
    marginRight: '5px',
    marginBottom: '0',
  },
}));

const StyledButton = muiStyled(Button)(({ theme, disabled }) => ({
  fontSize: '15px',
  fontStyle: 'italic',
  fontWeight: 700,
  color: disabled ? '#fff' : '#fff',
  width: '168.647px',
  height: '37.395px',
  borderRadius: '8px',
  border: '1px solid #ffffff',
  textAlign: 'center',
  cursor: disabled ? 'not-allowed' : 'pointer',
  transition: 'all 0.3s ease',
  background: disabled ? '#b0b0b0 !important' : '#017216 !important',
  opacity: disabled ? 0.5 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  boxShadow: disabled ? 'none' : '0 4px 10px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    background: disabled ? '#b0b0b0 !important' : 'linear-gradient(135deg, #218838, #2eb85c) !important',
  },
  '&:active': {
    transform: disabled ? 'none' : 'scale(0.97)',
  },
  '&:focus': {
    outline: 'none',
    boxShadow: disabled ? 'none' : '0 0 0 3px rgba(40, 167, 69, 0.4)',
  },
}));

const groupedOptions = [
  {
    label: "Category 1",
    options: [
      { value: 1, label: "Option 1" },
      { value: 2, label: "Option 2" },
    ],
  },
  {
    label: "Category 2",
    options: [
      { value: 3, label: "Option 3" },
      { value: 4, label: "Option 4" },
    ],
  },
];

const CreateStoryModal = ({
  open,
  onClose,
  onShowView = async () => { },
  onShowStreamView = async () => {},
  onStoryTitle = async () => {},
  from,
  isCanvasUser,
  chapter,
  page,
  storyData,
  data,
  content,
  customStyle = {},
  is_balcon,
  imageConfiguration
}) => {
  // Transform moodsOption data for Ant Design Select with grouped options
  const moodTenseOptions = useMemo(() => {
    return moodsOption.map(mood => ({
      label: mood.label,
      options: mood.tenseOptions.map(tense => ({
        label: tense.label || mood.label,
        value: `${mood.label}-${tense.label || mood.label}`
      }))
    }));
  }, []);

  const showAlert = useAlert();
  const isMobile = useMobileDetect();
  const classes = useStyles();
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const [gradeLevel, setGradeLevel] = useState("");

  const [selectableContent, setSelectableContent] = useState([]);
  const [fromPageIndex, setFromPageIndex] = useState(0);
  const [toPageId, setToPageId] = useState(null);
  const [pageContentCheck, setPageContentCheck] = useState(true);
  const [pageVocabCheck, setPageVocabCheck] = useState(false);
  const [selectedFromPage, setSelectedFromPage] = useState("");
  const [selectedToPage, setSelectedToPage] = useState("");

  const [loader, setLoader] = useState(false);
  const [storyPlot, setStoryPlot] = useState("");
  const [days, setDays] = useState("");
  const [ownVocab, setOwnVocab] = useState("");
  const [language, setLanguage] = useState("Spanish");
  const [genres, setGenres] = useState("");
  const [proficiencyLevel, setProficiencyLevel] = useState("");
  const [moodTense, setMoodTense] = useState("");
  const [wordCount, setWordCount] = useState("");
  const [longGenre, setLongGenre] = useState("");
  const [longProficiency, setLongProficiency] = useState("");
  const [fromPage, setFromPage] = useState();
  const location = useLocation();
  const pageChangedRef = useRef(null);
  const is_student = currentUser?.role === "student";
  const [openDropDown, setOpenDropDown] = useState({
    gradeLevel: false,
    state: false,
    genre: false,
    levelsData: false,
    wordCountData: false,
    timeFrame: false,
    days: false,
    standard: false,
    language: false,
    activities: false,
    from_page: false,
    to_page: false,
  });
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const storyContainerWidth = imageConfiguration?.clientWidth;
  const storyContainerHeight = imageConfiguration?.clientHeight;
  const { isAiPermissionEnabled } = useUserProfileConfig();
  useEffect(() => {
    if (page && ((data && data.content) || Array.isArray(content)) && chapter) {
      const contents = Array.isArray(content) ? content : data.content || [];
      const contentWithInformate = contents.map((k, i) => ({ ...k, page_dynamic_id: i + 1 }));
      setSelectableContent(
        contents.map((k, i) => ({ ...k, page_dynamic_id: i + 1 }))
      );

      setFromPage(page);
      setToPageId(null);
      const selectedIndex = contents.findIndex((bk) => bk.pageId == page);
      if (selectedIndex >= 0) {
        setSelectedToPage(contentWithInformate[selectedIndex].numberMasked);
        setSelectedFromPage(contents[selectedIndex].numberMasked);
        setFromPageIndex(selectedIndex);
      }
    }
  }, [data, page, chapter, content]);

  useEffect(() => {
    if (open) {
      if (pageChangedRef.current === null) {
        pageChangedRef.current = page;
      } else if (pageChangedRef.current !== page) {
        onClose();
        updatePopUpAtOnce(false);
      }
    } else {
      pageChangedRef.current = null;
    }
  }, [page, open, onClose, updatePopUpAtOnce]);

  const updateState = (name, value) => {
    setOpenDropDown((prev) => ({ ...prev, [name]: value }));
  };

  const handleGradeLevelChange = (event) => {
    setGradeLevel(event.target.value);
  };

  const handleToPageChange = (event) => {
    const selectedPageValue = event.target.value;
    const selectedIndex = selectableContent.findIndex(
      (bk) => bk.numberMasked == selectedPageValue
    );
    if (selectedIndex >= 0) {
      const selectedPageId = selectableContent[selectedIndex].pageId;
      if (parseInt(selectedPageId) - parseInt(fromPage) > 2) {
        showAlert(`Maximum 3 pages can be select.`);
      } else {
        setToPageId(selectedPageId);
        setSelectedToPage(event.target.value);
      }
    }
  };

  const handleFromPageChange = (event) => {
    const selectedPageValue = event.target.value;
    const selectedIndex = selectableContent.findIndex(
      (bk) => bk.numberMasked == selectedPageValue
    );
    if (selectedIndex >= 0) {
      const selectedPageId = selectableContent[selectedIndex].pageId;
      if (parseInt(toPageId) - parseInt(selectedPageId) > 2) {
        showAlert(`Maximum 3 pages can be select.`);
        return;
      }
    }
    if (selectableContent[selectedIndex]) {
      setFromPage(selectableContent[selectedIndex].pageId);
    }
    if (selectableContent[selectedIndex].pageId > toPageId) {
      setToPageId(null);
      setSelectedToPage("");
    }
    setSelectedFromPage(selectedPageValue);
    setFromPageIndex(selectedIndex);
  };

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  const handleGenresChange = (event) => {
    event.stopPropagation();
    setGenres(event.target.value);
  };

  const handleProficiencyLevelChange = (event) => {
    setProficiencyLevel(event.target.value);
  };

  const handleMoodTenseChange = (value) => {
    setMoodTense(value);
  };

  // Function to format the display value with mood in parentheses
  const formatDisplayValue = (value) => {
    if (!value) return undefined;
    const [mood, tense] = value.split('-');
    return `${tense} (${mood})`;
  };


  const handleWordCountChange = (event) => {
    setWordCount(event.target.value);
  };

  const clearAllState = () => {
    setGradeLevel("");
    setDays("");
  };

  const countStoryWords = (text) => {
    const trimmed = (text || "").trim();
    if (!trimmed) return 0;
    return trimmed.split(/\s+/).filter(Boolean).length;
  };

  async function streamData(inputData, onChunk) {
    try {
      const token = await getAwsAuthToken();
      const localUrl = 'http://localhost:4000/StoryAI/story-ai-stream';
      const prodUrl = `${sysConf.apiGateway.AI_BASE_NODE_URL}/StoryAI/story-ai-stream`;
      const response = await fetch(prodUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-source': sysConf.isDev ? 'test' : 'prod',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(inputData),
      });
  
      if (!response.ok || !response.body) {
        throw new Error('Stream failed to start');
      }
  
      const reader = response.body.getReader();
      const decoder = new TextDecoder('utf-8');
      let pendingEvent = null;
      let title = '';
      let story = '';
  
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
  
        const text = decoder.decode(value);
        const lines = text.split('\n').filter(Boolean);
  
        for (const line of lines) {
          if (line.startsWith('event:')) {
            pendingEvent = line.replace('event:', '').trim();
            continue;
          }
  
          if (!line.startsWith('data:')) continue;
  
          const data = line.replace('data:', '').trim();
  
          if (data === '[DONE]') {
            const inappropriateToast = 'Lo siento, pero no te puedo ayudar con eso';
            if (isErrorContent(story) || countStoryWords(story) <= 50) {
              setLoader(false);
              clearAllState();
              showAlert(inappropriateToast, 'error');
              onClose();
              return;
            }

            dispatch(handleListStoryAiConfig({
              chapter,
              user_id: get(currentUser, "id", ""),
              class_id: get(currentClass, "id", "")
            }, is_student));
            dispatch(handleLearningModuleCount({
              chapter: chapter,
              userId: get(currentUser, "id", ""),
              pageId: page,
            }));
            setLoader(false);
            clearAllState();
            onClose();
            return;
          }
  
          if (pendingEvent === 'title') {
            try {
              title = JSON.parse(data);
              onChunk({ type: 'title', content: title });
            } catch (err) {
              console.error('Failed to parse title JSON:', data);
            }
            pendingEvent = null;
            continue;
          }
  
          try {
            const parsed = JSON.parse(data);
  
            if (parsed.type === 'chunk') {
              story += parsed.content;
              onChunk({ type: 'chunk', content: parsed.content });
            }
  
            if (parsed.type === 'error') {
              console.error('Server error:', parsed.message);
              setLoader(false);
              clearAllState();
              const blockedMessage =
                parsed.code === 'INAPPROPRIATE_CONTENT'
                  ? 'Lo siento, pero no te puedo ayudar con eso'
                  : parsed.message || 'Failed to generate story. Please try again.';
              showAlert(blockedMessage, 'error');
              onClose();
              return;
            }
  
          } catch (err) {
            console.error('Failed to parse JSON:', data);
          }
        }
      }
    } catch (error) {
      console.error('Stream error:', error);
      setLoader(false);
      showAlert('An error occurred while generating the story. Please try again.', 'error');
    }
  }

   const checkUserHasFiveStory = useMemo(() => {
      const filterOwnStory = storyData.filter(record => 
        record?.role !== 'owe_admin' && Object.keys(record?.shared_from || {}).length === 0
      );
      return filterOwnStory?.length >= 6;
    },[storyData])

  const handleCreateLessonRef = useRef(null);

  const handleCreateLesson = useCallback(async () => {
    if (checkUserHasFiveStory){
      return showAlert(
        "You can only create 6 stories at a time, please delete any story before creating",
        "error"
      );
    }
    if (!isAiPermissionEnabled) {
      showAlert('Please enable AI permission to create a story.', 'error');
      return;
    }
    if (storyPlot) {
      const check_word = await checkInappropriateContent(storyPlot, 'story');
      if (check_word?.containsInappropriate) {
        const warning_text = check_word.foundWordsWithSynonyms.length > 0 ? check_word.foundWordsWithSynonyms.map(item => `"${item.word}" (use "${item.synonym}" instead)`).join(', ') : check_word.foundWords.map(item => `"${item.word}"`).join(', ');
        showAlert(`Inappropriate ${warning_text} Words Found`,"info");
        return;
      }
    }
    const payload = {
      grade_level: gradeLevel,
      genres,
      wordCount,
      proficiencyLevel,
      language,
      story_plot: storyPlot,
      ownVocab,
      page_content: {
        fromPage: fromPage,
        toPage: toPageId,
      },
      based_on: {
        page_content: pageContentCheck,
        page_vocab: pageVocabCheck,
      },
      mood_tense: moodTense,
    };
    const ckeck_story_ploat_word = await  checkInappropriateContent(storyPlot, 'story');
    const check_ownVocab_word = await checkInappropriateContent(ownVocab, 'vocabulary');
    if(ckeck_story_ploat_word.containsInappropriate||check_ownVocab_word.containsInappropriate){
      const words = check_ownVocab_word.foundWords.concat(ckeck_story_ploat_word.foundWords) ;
      const text = {
        storyPlot:ckeck_story_ploat_word.containsInappropriate?storyPlot:null,
        ownVocab: check_ownVocab_word.containsInappropriate?ownVocab:null,
      }
      handleAddInappropriateAlert(words, currentUser, currentClass, 'Soy Historias',text)
      return showAlert(`This word is not available in the dictionary. Please, try another word.`, "error");
    }
    const data = {
      user_id: get(currentUser, "id", ""),
      class_id: get(currentClass, "id", ""),
      chapter,
      page,
      content: payload,
      resource: from !== "ebook" ? true : false,
      mode: import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev",
    };
    setLoader(true);
    let fullHTML = "";
    let storyTitle = "";
    await streamData(data, (streamData) => {
      if (streamData.type === 'title') {
        storyTitle = streamData.content;
        onStoryTitle(streamData.content);
      } else if (streamData.type === 'chunk') {
        fullHTML += streamData.content;
        onShowStreamView(prev => prev + streamData.content)
      }
    });

    if (fullHTML && isErrorContent(fullHTML)) {
      showAlert(
        'Story generation failed. Please try with different parameters.',
        'error'
      );
      setLoader(false);
      return;
    }
  }, [
    checkUserHasFiveStory,
    isAiPermissionEnabled,
    storyPlot,
    gradeLevel,
    genres,
    wordCount,
    proficiencyLevel,
    language,
    ownVocab,
    fromPage,
    toPageId,
    pageContentCheck,
    pageVocabCheck,
    moodTense,
    chapter,
    page,
    from,
    currentUser,
    currentClass,
    dispatch,
    onStoryTitle,
    onShowStreamView,
    showAlert
  ]);

  const debouncedHandleCreateLesson = useMemo(() => {
    return debounce((...args) => {
      if (handleCreateLessonRef.current) {
        handleCreateLessonRef.current(...args);
      }
    }, 1000);
  }, []);

  useEffect(() => {
    handleCreateLessonRef.current = handleCreateLesson;
  }, [handleCreateLesson]);

  useEffect(() => {
    return () => {
      debouncedHandleCreateLesson.cancel();
    };
  }, [debouncedHandleCreateLesson]);

  const handleMenuOpen = (value) => {
    updateState(value, true);
  };

  const handleMenuClose = (value) => {
    updateState(value, false);
  };

  const handleScroll = () => {
    const openKeys = Object.keys(openDropDown).filter(
      (key) => openDropDown[key]
    );
    if (openKeys.length) {
      openKeys.forEach((key) => handleMenuClose(key));
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [openDropDown]);

  const renderSelectedValues = (selected) => {
    if (selected.length === 0) {
      return <span>Select</span>;
    }

    // Display up to 3 selected items directly, others in a tooltip
    const displayedItems = selected.slice(0, 1).map((value) => (
      <span key={value} className={classes.menuItemText}>
        {value}
      </span>
    ));

    const tooltipItems = selected.slice(1).map((value) => value);

    return (
      <Tooltip title={tooltipItems.join(", ")} placement="top">
        <div>
          {displayedItems}
          {selected.length > 1 && (
            <span className={classes.menuItemText}>...</span>
          )}
        </div>
      </Tooltip>
    );
  };

  const GenreTooltipContent = () => (
    <div>
      <ul style={{ paddingLeft: 16, margin: 0 }}>
        {genresSelection.map((item, index) => (
          <li key={index} style={{ fontSize: 13, marginBottom: 4,textTransform:'capitalize' }}>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );

  const getResponsiveWidth = () => {
    if (window.innerWidth <= 808) return "73%";
    if (window.innerWidth <= 715) return "67%";
    if (window.innerWidth <= 1199) return "68%";
    return "74%";
  };

  // add this near your other state
  const [vocabInput, setVocabInput] = useState("");
  const [vocabLoading, setVocabLoading] = useState(false);

  // small helpers
  const currentTokens = React.useMemo(
    () => ownVocab.split(",").map(s => s.trim()).filter(Boolean),
    [ownVocab]
  );

const validateVocabWord = async (word) => {
  if (!word.trim()) return { isValid: true };
  
  try {
    setVocabLoading(true);
    const check_word = await checkInappropriateContent(word.trim(), 'vocabulary');
    
    if (check_word?.containsInappropriate) {
      const warning_text = check_word.foundWordsWithSynonyms.length > 0 ? check_word.foundWordsWithSynonyms.map(item => `"${item.word}" (use "${item.synonym}" instead)`).join(', ') : check_word.foundWords.map(item => `"${item.word}"`).join(', ');
      showAlert(
        `Inappropriate ${warning_text} Words Found`,
        "info"
      );
      return { isValid: false, foundWords: check_word?.foundWords };
    }
    
    return { isValid: true };
  } catch (error) {
    console.error('Error validating vocabulary word:', error);
    showAlert("Error validating word. Please try again.", "error");
    return { isValid: false };
  } finally {
    setVocabLoading(false);
  }
};

// Enhanced commit function with validation
const commitTokens = async (parts) => {
  const cleaned = parts.map(s => s.trim()).filter(Boolean);
  if (!cleaned.length) return;

  // Validate each word before adding
  const validWords = [];
  for (const word of cleaned) {
    const validation = await validateVocabWord(word);
    if (validation.isValid) {
      validWords.push(word);
    } else {
      // Log inappropriate word attempt
      if (validation.foundWords) {
        const text = { ownVocab: word };
        handleAddInappropriateAlert(
          validation.foundWords, 
          currentUser, 
          currentClass, 
          'Soy Historias', 
          text
        );
      }
    }
  }

  if (validWords.length > 0) {
    const merged = Array.from(new Set([...currentTokens, ...validWords]));
    setOwnVocab(merged.join(","));
  }
};

  return (
    <SentryWrap>
      {open && (
        <MainContainerStory
          style={customStyle}
          className={
            `${isCanvasUser ? "canvasuperLessionModal" : "superLessionModal"} ${isMobile ? "loaderHeight" : "loaderHeightUnset"}`
          }
        >
          <CreateFormContainer
            loader={loader}
            localtionPage={location.pathname !== "/ebook"}
            isVideoPage={location.pathname === "/video"}
            isBalcon={location.pathname === "/balconCulturalBook"}
            isEbook={location.pathname === "/ebook"}
            width={storyContainerWidth}
            height={storyContainerHeight}
            className={`createMyLessionStory createMyLession storySelectedDropdown ${from !== "ebook" ? "create-lesson-modal manageSvgIcon" : "create-lesson-modals w-unset"
              } ${loader ? "createMyLessonLoader center-story-loader" : ""}`}
          >
            {loader ? (
              <div className="super-lesson-waiting">
                <PhraseLoader />{" "}
              </div>
            ) : (
              <UpperMainContainer height={storyContainerHeight}>
                <MainContainerSection>
                  <span
                    onClick={() => {
                       onClose();
                       updatePopUpAtOnce(false);
                    }}
                  >
                    <CancelIcon
                      style={{
                        position: "absolute",
                        right: -2,
                        top: -4,
                        fontSize: 22,
                        color: "red",
                        background: "white",
                        borderRadius: 20,
                        cursor: "pointer",
                      }}
                    />
                  </span>
                  <TitleContainer>
                    Generate Soy Historias With AI
                  <AiUsageModal />
                  </TitleContainer>
                  <FieldContainer className="allCreateMyLession">
                    <label>Grade Level *</label>
                    <StyledFormControl fullWidth>
                      <StyledSelect
                        input={<Input disableUnderline />}
                        value={gradeLevel}
                        onChange={handleGradeLevelChange}
                        displayEmpty
                        open={openDropDown?.gradeLevel}
                        onOpen={() => handleMenuOpen("gradeLevel")}
                        onClose={() => handleMenuClose("gradeLevel")}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                          disableScrollLock: true,
                        }}
                        renderValue={(selected) => {
                          if (!selected) return <span>Select</span>;
                          const selectedItem = gradeLevelData.find(item => item.value === selected);
                          return selectedItem ? selectedItem.label : selected;
                        }}
                      >
                        {gradeLevelData.map((item, index) => (
                          <MenuItem key={index} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </StyledSelect>
                    </StyledFormControl>
                  </FieldContainer>
                  {/* Genre */}
                  <FieldContainer className="allCreateMyLession">
                      <label>Genre  * <TooltipLevel
                        arrow={false}
                        trigger={["click"]}
                        title={<GenreTooltipContent />}
                        placement="top"
                        overlayStyle={{ maxWidth: window.innerWidth <= 740 ? 300 : 500 }}
                        color={"#3d5f8f"}
                      >
                        <span
                          style={{
                            display: "inline-flex",
                          }}
                        >
                          <InfoIcon style={{
                            fontSize: 25,
                            color: "white",
                            marginLeft: "4px",
                            cursor: "pointer",
                          }} />
                        </span>
                      </TooltipLevel>
                    </label>
                    <FormControl fullWidth>
                      <Select
                        className={classes.select}
                        value={genres}
                        onChange={handleGenresChange}
                        displayEmpty
                        open={openDropDown?.genre}
                        onOpen={() => handleMenuOpen("genre")}
                        onClose={() => handleMenuClose("genre")}
                        inputProps={{ "aria-label": "Without label" }}
                        input={<Input disableUnderline />}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                          disableScrollLock: true,
                        }}
                          renderValue={(selected) => {
                            setLongGenre(selected);
                          if (!selected) {
                            return <span>Select</span>;
                          }
                          const selectedItem = genresSelection.find(
                            (item) => item.label === selected
                          );
                            if (selectedItem) {
                              setLongGenre(selectedItem.label);
                            }
                          return (
                            <Tooltip
                              title={selectedItem ? selectedItem.label : ""}
                              placement="top"
                            >
                              <span className={classes.menuItemText}>
                                {selectedItem && typeof selectedItem.label === 'string'
                                  ? selectedItem.label : ''}
                              </span>
                            </Tooltip>
                          );
                        }}
                      >
                          {genresSelection.map((item, index) => (
                            <MenuItem style={{maxWidth: 500}} key={index} value={item?.label}>
                              <TooltipLevel zIndex={9999999} color={"#3d5f8f"} title={item?.label}> 
                                <span className="text-wrap">
                                  {item?.label && typeof item.label === 'string'
                                  ? item?.label : ''}
                                </span>
                              </TooltipLevel>
                            </MenuItem>
                          ))}
                        
                      </Select>
                    </FormControl>
                  </FieldContainer>
                  {/* Word Count */}
                  <FieldContainer className="allCreateMyLession">
                    <label>Word Count *</label>
                    <FormControl fullWidth>
                        <Select
                        input={<Input disableUnderline />}
                        className={classes.select}
                        value={wordCount}
                        onChange={handleWordCountChange}
                        displayEmpty
                        open={openDropDown?.wordCountData}
                        onOpen={() => handleMenuOpen("wordCountData")}
                        onClose={() => handleMenuClose("wordCountData")}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                          disableScrollLock: true,
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return <span>Select</span>;
                          }
                          const selectedItem = wordCountData.find(
                            (item) => item.label === selected
                          );
                          return (
                            <Tooltip
                              title={selectedItem ? selectedItem.label : ""}
                              placement="top"
                            >
                              <span className={classes.menuItemText}>
                                {/* {selectedItem
                                ? selectedItem.label?.length > 10
                                  ? selectedItem?.label.slice(0, 10) + "..."
                                  : selectedItem?.label
                                : ""} */}
                                {selectedItem.label ?? ""}
                              </span>
                            </Tooltip>
                          );
                        }}
                      >
                        {wordCountData.map((item, index) => (
                          <MenuItem key={index} value={item?.label}>
                            {item?.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </FieldContainer>
                  <FieldContainer width={"77%"} className="allCreateMyLession proficiy" borderRadius={"30px"}>
                      <label>Proficiency Level * <TooltipLevel
                        arrow={false} 
                        title={<ProficiencyTooltipContent />}
                        placement="top"
                        overlayStyle={{ maxWidth:window.innerWidth <= 740 ? 300 : 500 }}
                        color={"#3d5f8f"}
                        trigger={["click"]}
                      >
                        <span
                          style={{
                            display: "inline-flex",
                          }}
                        >
                          <InfoIcon style={{
                            fontSize: 25,
                            color: "white",
                            marginLeft: "4px",
                            cursor: "pointer",
                          }} />
                        </span>
                      </TooltipLevel></label>
                    <FormControl fullWidth>
                        <Select
                          input={<Input disableUnderline />}
                        className={classes.select}
                        value={proficiencyLevel}
                        onChange={handleProficiencyLevelChange}
                        displayEmpty
                        open={openDropDown?.levelsData}
                        onOpen={() => handleMenuOpen("levelsData")}
                        onClose={() => handleMenuClose("levelsData")}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                          disableScrollLock: true,
                        }}
                          renderValue={(selected) => {
                            setLongProficiency(selected);
                          if (!selected) {
                            return <span>Select</span>;
                          }
                          const selectedItem = levelsData.find(
                            (item) => item.label === selected
                          );
                          return (
                            <Tooltip
                              title={selectedItem ? selectedItem.label : ""}
                              placement="top"
                            >
                              <span className={classes.menuItemText}>
                                {selectedItem && typeof selectedItem.label === 'string'
                                  ? selectedItem.label : ''}
                              </span>
                            </Tooltip>
                          );
                        }}
                      >
                        {levelsData.map((item, index) => (
                          <MenuItem style={{maxWidth: 500}} key={index} value={item?.label}>
                          <TooltipLevel zIndex={9999999} color={"#3d5f8f"} title={item?.label}> 
                            <span className="text-wrap">
                              {item?.label && typeof item.label === 'string'
                              ? item?.label : ''}
                            </span>
                          </TooltipLevel>
                        </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </FieldContainer>
                  <FieldContainer width={"77%"} className="allCreateMyLession proficiy" borderRadius={"30px"}>
                      <label>Mood / Tense  </label>
                    <FormControl fullWidth style={{ backgroundColor: 'transparent'  , padding: '0px' , paddingTop: '0px !important'}}>
                      <StyledAntSelect
                        placeholder="Select"
                        value={moodTense ? { value: moodTense, label: formatDisplayValue(moodTense) } : undefined}
                        onChange={(value) => handleMoodTenseChange(value.value)}
                        options={moodTenseOptions}
                        showSearch
                        labelInValue
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </FormControl>
                  </FieldContainer>
                  {from === "ebook" && (
                    <FieldContainer className="allCreateMyLession">
                      <label>
                        Select Page Content
                      </label>
                      <TwoFiledContainer style={{ width: "79%" }} width={"50%"}>
                        <FormControl fullWidth>
                            <Select
                            input={<Input disableUnderline />}
                            className={classes.select}
                            value={selectedFromPage}
                            onChange={handleFromPageChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            open={openDropDown?.from_page}
                            onOpen={() => handleMenuOpen("from_page")}
                            onClose={() => handleMenuClose("from_page")}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              getContentAnchorEl: null,
                              disableScrollLock: true,
                            }}
                          >
                            {map(selectableContent, (bk, index) => (
                              <MenuItem key={index} value={bk.numberMasked}>
                                {is_balcon
                                  ? bk.page_dynamic_id
                                  : bk.numberMasked}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <Select
                            input={<Input disableUnderline />}
                            className={classes.select}
                            value={selectedToPage}
                            disabled={!selectedFromPage}
                            onChange={handleToPageChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            open={openDropDown?.to_page}
                            onOpen={() => handleMenuOpen("to_page")}
                            onClose={() => handleMenuClose("to_page")}
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              getContentAnchorEl: null,
                              disableScrollLock: true,
                            }}
                          >
                            {map(
                              selectableContent.slice(fromPageIndex),
                              (bk, index) => (
                                <MenuItem key={index} value={bk.numberMasked}>
                                  {is_balcon
                                    ? bk.page_dynamic_id
                                    : bk.numberMasked}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>

                      </TwoFiledContainer>
                    </FieldContainer>
                  )}
                  <FieldContainer className="allCreateMyLession">
                    <label style={{ minWidth: "fit-content" }}>
                      Create Base On
                    </label>
                      <TwoFiledContainerCheck width={"50%"} className="createbaseOnStyling">
                      <FormControl fullWidth>
                        <FormGroup row>
                          <FormControlLabel
                            label={
                              <span style={{ color: "black" }}>{from === "ebook" ? "Page Vocab" : "Video Vocab"}</span>
                            }
                            control={
                              <Checkbox
                                checked={pageVocabCheck}
                                onChange={(e) =>
                                  setPageVocabCheck(e.target.checked)
                                }
                                sx={{
                                  '&.Mui-checked':{
                                    color:'#f50057',
                                  }
                                }}
                              />
                            }
                          />
                        </FormGroup>
                      </FormControl>
                      <FormControl fullWidth>
                        <FormGroup row>
                          <FormControlLabel
                            label={
                              <span style={{ color: "black" }}>{from === "ebook" ? "Page Content" : "Video Subtitles"}</span>
                            }
                            control={
                              <Checkbox
                                checked={pageContentCheck}
                                onChange={(e) =>
                                  setPageContentCheck(e.target.checked)
                                }
                                sx={{
                                  '&.Mui-checked':{
                                    color:'#f50057',
                                  }
                                }}
                              />
                            }
                          />
                        </FormGroup>
                      </FormControl>
                    </TwoFiledContainerCheck>
                  </FieldContainer>
                  <FieldContainer className="allCreateMyLession">
                    <label>Language</label>
                    <FormControl fullWidth>
                        <Select
                        input={<Input disableUnderline />}
                        className={classes.select}
                        value={language}
                        onChange={handleLanguageChange}
                        displayEmpty
                        open={openDropDown?.language}
                        onOpen={() => handleMenuOpen("language")}
                        onClose={() => handleMenuClose("language")}
                        inputProps={{ "aria-label": "Without label" }}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                          disableScrollLock: true,
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return <span>Select</span>;
                          }
                          const selectedItem = languageItems.find(
                            (item) => item.label === selected
                          );
                          return (
                            <Tooltip
                              title={selectedItem ? selectedItem.label : ""}
                              placement="top"
                            >
                              <span className={classes.menuItemText}>
                                {selectedItem
                                  ? selectedItem.label?.length > 10
                                    ? selectedItem?.label.slice(0, 10) + "..."
                                    : selectedItem?.label
                                  : ""}
                              </span>
                            </Tooltip>
                          );
                        }}
                      >
                        {languageItems.map((item, index) => (
                          <MenuItem key={index} value={item?.label}>
                            {item?.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </FieldContainer>
                  <FieldContainer width={"100%"} className="allCreateMyLession allCreateMyLessionStory">
                    <VocContainer>
                      <label style={{whiteSpace: 'nowrap'}}>Add Your Vocab</label>
                      <StyledAutocomplete
                        multiple
                        freeSolo
                        id="tags-outlined"
                        options={[]}
                        value={currentTokens}
                        inputValue={vocabInput}
                        loading={vocabLoading}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === "input") {
                            if (newInputValue.includes(",")) {
                              commitTokens(newInputValue.split(","));
                              setVocabInput("");
                            } else {
                              setVocabInput(newInputValue);
                            }
                          }
                        }}
                        onKeyDown={async (event) => {
                          // Prevent comma insertion
                          if (event.key === ",") {
                            event.preventDefault();
                            if (vocabInput.trim() && !vocabLoading) {
                              await commitTokens([vocabInput]);
                              setVocabInput("");
                            }
                          }
                          
                          // Commit on Enter
                          if (event.key === "Enter") {
                            event.preventDefault();
                            if (vocabInput.trim() && !vocabLoading) {
                              await commitTokens([vocabInput]);
                              setVocabInput("");
                            }
                          }
                        }}
                        
                        onChange={async (event, value) => {
                          // Handle chip removal (no validation needed for removal)
                          if (value.length < currentTokens.length) {
                            setOwnVocab(value.join(","));
                          } else {
                            // Handle new additions through commitTokens for validation
                            const newWords = value.filter(word => !currentTokens.includes(word));
                            if (newWords.length > 0) {
                              await commitTokens(newWords);
                            }
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              endAdornment: (
                                <>
                                  {vocabLoading ? (
                                    <Loading size={15} style={{ marginRight: 8 }} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                              sx: {
                                border: "none",
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            placeholder={vocabLoading ? "Validating..." : "Optional."}
                            disabled={vocabLoading}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              variant="outlined"
                              label={option}
                              {...getTagProps({ index })}
                              key={index}
                              disabled={vocabLoading}
                              sx={{
                                marginRight: "5px",
                                marginBottom: "0",
                              }}
                            />
                          ))
                        }
                        PopperComponent={() => null} 
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            padding: 0,
                            border: "none",
                            "& fieldset": {
                              display: "none",
                            },
                          },
                          "& .MuiInputBase-root::before, & .MuiInputBase-root::after": {
                            display: "none !important",
                          },
                          "& .MuiAutocomplete-listbox": {
                            display: "flex",
                            flexDirection: "row",
                            overflowX: "auto",
                            maxWidth: "100%",
                            whiteSpace: "nowrap",
                          },
                          "& .MuiAutocomplete-tag": {
                            marginRight: "5px",
                            marginBottom: "0",
                          },
                        }}
                      />
                    </VocContainer>
                  </FieldContainer>
                  <LessonContainer>

                    <Label>Story Plot</Label>
                    <StyledStoryTextField
                      minRows={3}
                      value={storyPlot}
                      onChange={(event) => setStoryPlot(event.target.value)}
                      multiline
                      fullWidth
                      variant="outlined"
                      placeholder="You can leave this blank if you would like forus to create a plot for you."
                    />

                  </LessonContainer>
                    <ButtonWrapper>
                    <StyledButton
                      disabled={
                        loader || !(gradeLevel && genres && wordCount && proficiencyLevel)
                      }
                      onClick={debouncedHandleCreateLesson}
                      variant="contained"
                    >
                      {loader ? (
                        <>
                          <Loading size={17} />
                          &nbsp;Creating...
                        </>
                      ) : (
                        "Create my story"
                      )}
                    </StyledButton>
                  </ButtonWrapper>
                </MainContainerSection>
                <CreatedTopicContnt className="createdTopicContnt">
                  <span>
                    Note: The story will be generated based on the information
                    you provided. Please review it carefully to ensure it aligns
                    with the appropriate grade level and meets the needs of your
                    students.
                  </span>
                </CreatedTopicContnt>
              </UpperMainContainer>
            )}
          </CreateFormContainer>
        </MainContainerStory>
      )}
    </SentryWrap>
  );
};

export default CreateStoryModal;